var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgDetailW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 82,
    viewBox: "0 0 317 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_416_10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317,
    height: 82,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.773,
    y: 73.0378,
    width: 10.4678,
    height: 10.4678,
    rx: 3.0453,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.486 41.4905H269.401C268.327 41.4905 267.35 42.1113 266.893 43.0836L249.762 79.5564C248.899 81.3942 250.24 83.5057 252.27 83.5057H263.539C264.617 83.5057 265.598 82.8802 266.052 81.9022L282.999 45.4294C283.853 43.5926 282.511 41.4905 280.486 41.4905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.577 41.4905H314.553C316.576 41.4905 317.917 43.5882 317.068 45.4246L309.87 60.9959C309.416 61.9764 308.434 62.6042 307.354 62.6042H292.044L300.153 79.5376C301.034 81.377 299.693 83.5057 297.654 83.5057H286.59C285.515 83.5057 284.538 82.8846 284.081 81.912L276.872 66.5528C276.01 64.7151 277.351 62.6042 279.381 62.6042H292.044L301.062 43.0988C301.515 42.1182 302.497 41.4905 303.577 41.4905Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDetailW);
export default __webpack_public_path__ + "static/media/BgDetailW.bd7bdf2dad0b8c133b662386daccc3e1.svg";
export { ForwardRef as ReactComponent };